/* lua.js generated code 0.1 */

// if (__ANDROID) {
//     var deviceType = he.MetaInfo.getInstance()[0].getMachineType()[0] || ""
//     if (string.sub(deviceType, 1, 5) === "GT-I9") {
//         cc.Image.allowTextureHardwareDecoding(false)
//     }
// } else if (__WIN32) {
//     if (FetchConsoleCmd) {
//         debug.debug = debugDebug
//         function onError(msg) {
//             cc.log(msg)
//         }
//         cc.Director.getInstance().getScheduler().scheduleScriptFunc(function () {
//             let str = FetchConsoleCmd()
//             if (str) {
//                 let cmd = loadstring(str)
//                 if (cmd) {
//                     xpcall(cmd, onError)
//                 }
//             }
//         }, 1 / 60, false)
//     }
// }

let ratio = (window.innerWidth / window.innerHeight).toFixed(2)

__IPHONEX = 0
__NEED_HIGHP_FOR_HUE = 0
// 微信小游戏模拟器内platform不对
if (cc.sys.platform === cc.sys.WECHAT_GAME) {
    let model = mini.getSystemInfoSync().model
    if (model === 'iPhone X') {
        __IPHONEX = 1
    } else if (model.includes('iPhone 6')) {
        __NEED_HIGHP_FOR_HUE = 1
    }
}
if (cc.sys.os === cc.sys.OS_IOS) {
    if (ratio == 0.46) {
        __IPHONEX = 1
    } else if (ratio == 0.56) {
        // 判断不了iphone 6，6 7 8 ratio一样，全开
        __NEED_HIGHP_FOR_HUE = 1
    }
}

applySafeArea()
